import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/drawer-actions";
import { TYPES as REVIEW_SHORT_TYPES } from "../actions/review-short-actions";

const drawerReducer = (state = INITIAL_STATE.drawer, action) => {
  switch (action.type) {
    case TYPES.OPEN_DRAWER: {
      return {
        open: true,
      };
    }

    case TYPES.CLOSE_DRAWER: {
      return {
        open: false,
      };
    }

    case REVIEW_SHORT_TYPES.OPEN_REVIEW_SHORT_OFFCANVAS: {
      return {
        open: false,
      };
    }

    default:
      return state;
  }
};

export default drawerReducer;
